import { Component, Inject, Injector, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

import { BehaviorSubject, Subscription } from 'rxjs';

import { ActionService, AuthService, FileService, ISitemap, ResolverLoadingService, SITEMAP } from 'pbc.angular';

import { IAbteilung, IDeleteAbteilungRequest, IDeleteAbteilungResponse, IPostAbteilungRequest, IPostAbteilungResponse } from 'fa-kt.types';
import { DeleteAbteilungCommandService, PostAbteilungCommandService } from '../..';

@Component({
  selector: 'fa-kt-abteilungen',
  templateUrl: './abteilungen.component.html',
  styleUrls: ['./abteilungen.component.css'],
})
export class AbteilungenComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];

  public readonly $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public readonly $deleteAbteilung: BehaviorSubject<IDeleteAbteilungRequest | null> = new BehaviorSubject<IDeleteAbteilungRequest | null>(null);
  public readonly $postAbteilung: BehaviorSubject<IPostAbteilungRequest | null> = new BehaviorSubject<IPostAbteilungRequest | null>(null);

  @Input() disabled = false;
  @Input() kunde: string = '';
  @Input() businessHomePage = '';
  @Input() companyName = '';
  @Input() abteilungen: any[] = [];

  get modalRef() {
    return this.injector.get(NzModalRef);
  }

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private modal: NzModalService,
    private message: NzMessageService,
    private actions: ActionService,
    private loading: ResolverLoadingService,
    public auth: AuthService,
    public files: FileService,
    public deleteAbteilung: DeleteAbteilungCommandService,
    public postAbteilung: PostAbteilungCommandService,
  ) {}

  async ngOnInit() {
    this.subscriptions.push(
      ...[
        this.route.queryParams.subscribe(async (params: Params) => {}),
        /* << subscriptions    */
        /*    subscriptions >> */
      ],
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  async finishedDeleteAbteilung(response?: IDeleteAbteilungResponse) {
    /* << after delete-abteilung    */
    this.openAbteilung(null);
    /*    after delete-abteilung >> */
  }

  async finishedPostAbteilung(response?: IPostAbteilungResponse) {
    /* << after post-abteilung    */
    this.openAbteilung(null);
    /*    after post-abteilung >> */
  }

  /* << methods    */
  public openAbteilung(abteilung: IAbteilung | null | any) {
    if (!abteilung) {
      this.$postAbteilung.next(null);
      this.$deleteAbteilung.next(null);
      return;
    }
    if (!abteilung.id) {
      abteilung.aktiv = true;
      abteilung.kunde = this.kunde;
    }
    this.$postAbteilung.next({ abteilung });
    if (abteilung && abteilung.id) {
      this.$deleteAbteilung.next({ id: abteilung.id });
    } else {
      this.$deleteAbteilung.next(null);
    }
  }
  /*    methods >> */

  public async submitDeleteAbteilung(request?: IDeleteAbteilungRequest) {
    this.$loading.next(true);
    const payload = request ? request : this.$deleteAbteilung.getValue();
    if (payload) {
      try {
        const response = await this.deleteAbteilung.request(payload);
        await this.finishedDeleteAbteilung(response);
      } catch (error: any) {
        this.message.error('Oops, etwas ist schief gelaufen' + (error && error.message ? ': ' + error.message : ''));
        console.error(error);
      }
    }
    this.$loading.next(false);
  }

  public async submitPostAbteilung(request?: IPostAbteilungRequest) {
    this.$loading.next(true);
    const payload = request ? request : this.$postAbteilung.getValue();
    if (payload) {
      try {
        const response = await this.postAbteilung.request(payload);
        await this.finishedPostAbteilung(response);
      } catch (error: any) {
        this.message.error('Oops, etwas ist schief gelaufen' + (error && error.message ? ': ' + error.message : ''));
        console.error(error);
      }
    }
    this.$loading.next(false);
  }
}
